import { useTranslation } from "react-i18next";
import { ILod } from "interface";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "components/context/authContext";
import "./lod.scss";

type ILodCard = {
  lod: ILod;
};

const LodCard = ({ lod }: ILodCard) => {
  const navigate = useNavigate();
  const { setLodInf } = useAuthContext();
  return (
    <div
      className="lod-card"
      onClick={() => {
        navigate(`/${lod.lodNo}`, {
          state: {
            lodNo: lod.lodNo,
          },
        });
        setLodInf(lod);
        localStorage.setItem("lodInf", JSON.stringify(lod));
      }}
    >
      <h4 className="pb-2">{lod?.lodNm}</h4>
      <ul>
        <li>
          <p icon-telno={"true"}>{lod.telNo}</p>
        </li>
        <li>
          <p icon-eml={"true"}>{lod.lodEml}</p>
        </li>
        <li>
          <p icon-addr={"true"}>
            <a href={lod.hpUrl} target="_bank">
              {lod.hpUrl}
            </a>
          </p>
        </li>
      </ul>
    </div>
  );
};

type IProps = {
  lodList: ILod[];
};

export default function LodList({ lodList }: IProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="text-center font-font-B pt-10">
        {lodList.length === 0 && (
          <>
            <h5>{t("txt_no_list_1_cmm")}</h5>
            <h5>{t("txt_no_list_2_cmm")}</h5>
          </>
        )}
      </div>
      <div className="start-center gap-4 flex-wrap  ">
        {lodList.map((lod) => {
          return <LodCard key={lod.lodNo} lod={lod} />;
        })}
      </div>
    </>
  );
}
